<template>
  <b-container fluid>
    <b-row align-h="center" align-v="center">
      <b-col col class="practicienne" cols="12" md="3">
        <b-row
          align-h="center"
          align-v="center"
          class="practicienne-picture"
          data-aos="fade-down"
          @mouseover="imgActive = false"
          @mouseout="imgActive = true"
          :style="Background"
        >
          <a
            :href="link"
            :class="{ hidden: imgActive }"
            target="_blank"
            class="btn btn-primary mx-auto my-auto"
          >
            Prendre rendez-vous
          </a>
        </b-row>
      </b-col>
      <b-col col class="practicienne" cols="12" md="6">
        <b-row align-h="center" align-v="center" data-aos="fade-down">
          <h1>
            <span class="firstname">{{ firstname }}</span>
            {{ surname }}
          </h1>
        </b-row>
        <b-row class="text">
          <div class="description formation">{{ formation }}</div>
        </b-row>
        <b-row class="text">
          <div class="description location">{{ location }}</div>
        </b-row>
        <b-row class="text">
          <div class="description text">
            {{ text }}
          </div>
        </b-row>
        <b-row class="text">
          <div class="description skills">
            <u>Mon petit plus</u>: {{ skills }}
          </div>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: [
    "firstname",
    "surname",
    "formation",
    "picture",
    "skills",
    "location",
    "text",
    "link",
  ],
  data() {
    return { imgActive: true };
  },
  computed: {
    Picture() {
      return require("../assets/images/" + this.picture);
    },
    Background() {
      return "background-image: url(" + this.Picture + ")";
    },
  },
};
</script>

<style lang="stylus">
h1 {
  color: #30475e;
}

.btn-primary,
.btn-primary:hover,
.btn-primary:active,
.btn-primary:visited,
.btn-primary:focus {
    background-color: #f5b971;
    border-color: #85a392;
    color:#30475e;
}

.hidden {
    display: none !important;
}

.rdv {
    height: 30vh;
    width: 100%;
}

.practicienne-picture {
  width: 100%;
  height: 400px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.practicienne-picture:hover {
    opacity: 0.1;
}

.practicienne {
  margin-top: 50px;
  padding-left: 50px;
}

.firstname {
  color: #f5b971;
}

.description {
  min-height: 40px;
  padding-left: 50px;
  margin-top: 10px;
  background-position: left top;
  background-size: 40px 40px;
  background-repeat: no-repeat;
}

.description.formation {
  background-image: url('../assets/icons_keyword/education.svg');
}

.description.location {
  background-image: url('../assets/icons_keyword/medical.svg');
}

.description.skills {
  background-image: url('../assets/icons_keyword/star.svg');
}

.description.text {
  background-image: url('../assets/icons_keyword/skills.svg');
    }
</style>
